import * as React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function PercentageBar(props) {
  return (
    <Box sx={{ width: "100%", position: "relative", display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", height: 15, backgroundColor: "#ddd", borderRadius: 5, position: "relative"}}>
        <Box
            sx={{
                width: `${props.value}%`,
                height: "100%",
                backgroundColor: props.color ? props.color : "#92B3EC",
                borderRadius: 5,
            }}
        />        
      </Box>

      <Typography
        sx={{
            position: "absolute",
            width: "100%",
            textAlign: "center",
            fontSize: 12,
            fontWeight: "bold",
            color: "#000"
        }}
      >
        {props.value}%
      </Typography>
    </Box>
  );
}

export default PercentageBar;

PercentageBar.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};